import React from "react";
import classes from "./CategoryDescrption.module.scss";

const STATIC_CATEGORY_DATA = {
  jewellery: {
    title: "Jewellery",
    description:
      "Discover our exquisite collection of handcrafted jewellery featuring certified natural diamonds and precious gemstones. From elegant everyday pieces to statement designs, find the perfect jewellery to complement your style.",
  },
  trending: {
    title: "Trending Jewellery",
    description:
      "Explore the latest trending jewellery designs that are making waves this season. Stay ahead of the curve with our curated selection of contemporary styles and timeless favourites.",
  },
};

const CategoryDescription = (props) => {
  const { categoryTitle, categoryDescription, categorySlug, loading } = props;

  const staticData = STATIC_CATEGORY_DATA[categorySlug];
  const title = categoryTitle || (staticData && staticData.title);
  const description = categoryDescription || (staticData && staticData.description);

  if (!title) {
    if (!loading) return null;
    return (
      <div className={`${classes.category_description} ${classes.skeleton_wrapper} d-none d-xl-block`}>
        <div className={classes.skeleton_title} />
        <div className={classes.skeleton_lines}>
          <div className={`${classes.skeleton_line} ${classes.skeleton_line_full}`} />
          <div className={`${classes.skeleton_line} ${classes.skeleton_line_wide}`} />
          <div className={`${classes.skeleton_line} ${classes.skeleton_line_medium}`} />
        </div>
      </div>
    );
  }

  return (
    <div className={`${classes.category_description} d-none d-xl-block`}>
      <h1 className={classes.title}>{title}</h1>
      {description && <p>{description}</p>}
    </div>
  );
};

export default CategoryDescription;
